import React from 'react';
import PressPalletIcon from "../PressPalletIcon";
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import * as yup from "yup";
import {makeStyles} from "@material-ui/core/styles";
import {onStartPallet, operatorExists} from './PalletBuilderController';
import FabCountdownButton from "../../../framework/util/uicomps/progress/FabCountdownButton";
import BaseAdHocPage from "../../../framework/util/uicomps/BaseAdHocPage";
import CurrentAndLastPalletView from "./CurrentAndLastPalletView";
import PalletSummary from "../palletsummary/PalletSummary";

const validationStartBuilding = yup.object({
    unloadOperatorId: yup.string().required().test('unloadOperatorId', 'Operator id does not exist', operatorExists)
});


const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    refreshFab: {
        align: 'center',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(3),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
}));


const BuildPalletUIPalletBuilding = ({currentState, sendEvent}, {...props}) => {

    const [currentShowing, setCurrentShowing] = React.useState(true);

    const refreshSeconds = 5 * 60;

    const classes = useStyles();

    const pallet = currentState.context.pallet;
    if (!pallet)
        throw 'No pallet';

    const lastPallet = currentState.context.lastPallet;

    const submitButton = (
        <Button type="submit" variant="contained" color="primary" fullWidth onClick={() => {
            sendEvent('ENDPALLET', {});
        }}>
            Unload Pallet
        </Button>);

    const cancelButton = (<Button variant="contained" onClick={() => {
        sendEvent('CANCEL');
    }}>
        Cancel
    </Button>);


    const refreshButton2 = (
        <FabCountdownButton immediate={true} refreshFunc={() => sendEvent('REFRESH')} seconds={refreshSeconds}
                            className={classes.refreshFab}/>);


    const contentItems = [];

    const summary = (<PalletSummary pallet={pallet} lastPallet={lastPallet}/>)


    contentItems.push(summary);

    const buttonItems = [];
    buttonItems.push(
        <Grid container
              direction="row"
              justify="center"
              alignItems="center"
        >
            <Grid item xs={3}>
                {cancelButton}
            </Grid>
            <Grid item xs={4}>

            </Grid>
            <Grid item xs={4}>
                {submitButton}
            </Grid>
            <Grid item xs={1}>
                {refreshButton2}
            </Grid>
        </Grid>
    );

    const Page = (

        <BaseAdHocPage icon={<PressPalletIcon/>} title={'Pallet Is Loaded (' + pallet.stationInfo?.name + ')'}
                       description={'Printed jobs will be associated with this pallet.  Click unload pallet to start another.'}
                       buttons={buttonItems}
                       content={contentItems}/>
    );

    const PageInGrid = (

        <Grid container
              direction="row"
              justify="center"
              alignItems="center"
        >
            <Grid item xs={2}>
            </Grid>
            <Grid item xs={8}>
                {Page}
            </Grid>
            <Grid item xs={2}>
            </Grid>
        </Grid>

    );


    return PageInGrid;

}


export default BuildPalletUIPalletBuilding;